import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export function AuthCallback() {
  const { exchangeGoogleSession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    exchangeGoogleSession(sessionId)
      .then((user) => {
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Benvenuto, ${user.name || "utente"}!`);
        navigate(user.role === "professional" ? "/pro" : "/home", { replace: true, state: { user } });
      })
      .catch(() => {
        toast.error("Accesso con Google non riuscito");
        navigate("/login", { replace: true });
      });
  }, [exchangeGoogleSession, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3" data-testid="auth-callback-loading">
      <Loader2 className="w-8 h-8 animate-spin text-whoo" />
      <p className="text-sm text-slate-500">Accesso in corso...</p>
    </div>
  );
}
